import { z } from 'zod'

export const roleSchema = z.enum(['growth_team', 'partner', 'company_editor', 'company_viewer'])

export type Role = z.infer<typeof roleSchema>

export function isPortfolioRole(role: Role): boolean {
  return role === 'growth_team' || role === 'partner'
}

export type GatedPage = 'portfolio' | 'company' | 'admin' | 'files' | 'askAi'

export function canOpenPage(role: Role | null, page: GatedPage): boolean {
  if (page === 'company' || page === 'files') {
    return true
  }

  return role === null || isPortfolioRole(role)
}

export function canUploadDocuments(role: Role | null): boolean {
  return role === null || role === 'growth_team' || role === 'company_editor'
}

export function canDeleteDocuments(role: Role | null): boolean {
  return role === null || role === 'growth_team' || role === 'company_editor'
}

export function canDownloadDocuments(): boolean {
  return true
}

export function canConfigureScoring(role: Role | null): boolean {
  return role === null || role === 'growth_team'
}

export function canAddCompanies(role: Role | null): boolean {
  return role === null || role === 'growth_team'
}

export function canRescoreCompany(role: Role | null): boolean {
  return role === null || role === 'growth_team' || role === 'company_editor'
}

function pageForPath(path: string): GatedPage | null {
  if (path === '/') return 'portfolio'
  if (path === '/company' || path.startsWith('/company/')) return 'company'
  if (path === '/admin' || path.startsWith('/admin/')) return 'admin'
  if (path === '/ask-ai') return 'askAi'
  if (path === '/files' || path.startsWith('/files/')) return 'files'

  return null
}

export function canOpenPath(role: Role | null, path: string): boolean {
  const page = pageForPath(path)

  return page === null || canOpenPage(role, page)
}
